import { playerEnteredFullscreenAction } from 'app-webtech-core/modules/player/actions/enteredFullscreen';
import { guidePlayChannelAtIndexThunkAction } from './playChannelAtIndex';

export const guidePlayChannelFullscreenThunkAction = ({ index, setSelected = false }) => async (
  dispatch,
) => {
  await dispatch(guidePlayChannelAtIndexThunkAction({ index, setSelected }));
  dispatch(playerEnteredFullscreenAction());
};
